/**
 * Official product wordmarks for dark marketing surfaces.
 * Assets are the shipping app brand marks, resized for the website.
 *
 * Size presets keep Halo / SecureShield / SecureShield Pro heroes on one scale.
 */
const PRODUCTS = Object.freeze({
  quantumcloak: {
    src: "/quantumcloak/quantumcloak-official-wordmark-929a52ca.png",
    alt: "QuantumCloak",
    officialLockup: true,
    width: 2172,
    height: 724,
  },
  quantumcubedb: {
    src: "/quantumcubedb/qdb-official-wordmark-a0884f92.png",
    alt: "QuantumCubeDB (QDB)",
    officialLockup: true,
    width: 2172,
    height: 724,
  },
  "securemac-pro": {
    src: "/secureshield/secure-shield-pro-wordmark-804b7e30.png",
    alt: "SecureShield Pro",
    officialLockup: true,
    width: 2172,
    height: 724,
  },
  securemac: {
    src: "/secureshield/secure-shield-wordmark-2bdccab0.png",
    alt: "SecureShield",
    officialLockup: true,
    width: 2172,
    height: 724,
  },
  halo: {
    src: "/halo/official-halo-wordmark.png",
    alt: "Halo SuperVPN",
    width: 1000,
    height: 234,
  },
});

/** Shared visual scale — do not override height/max-width per page. */
export const PRODUCT_WORDMARK_SIZES = Object.freeze({
  // Was h-9/md:h-11 (~36/44px). ~2–2.2× with room for wide Halo lockup.
  hero: "mb-10 h-[4.5rem] w-auto max-w-[min(100%,36rem)] md:mb-12 md:h-24 md:max-w-[44rem]",
  // Was h-12/md:h-14. Track hero scale inside the Network Guard filler cell.
  grid: "h-20 w-auto max-w-[min(100%,32rem)] md:h-24 md:max-w-[40rem]",
});

// The supplied 3:1 PNG lockups include the shield and glow. Width-led sizing
// keeps their lettering legible without cropping the approved artwork.
const OFFICIAL_SHIELD_WORDMARK_SIZES = Object.freeze({
  hero: "mb-6 h-auto w-full max-w-[30rem] md:mb-8 md:max-w-[36rem]",
  grid: "h-auto w-full max-w-[26rem] md:max-w-[32rem]",
});

/**
 * @param {{
 *   product: keyof typeof PRODUCTS,
 *   size?: keyof typeof PRODUCT_WORDMARK_SIZES,
 *   className?: string,
 *   testId?: string,
 *   loading?: "eager"|"lazy",
 * }} props
 */
export default function ProductWordmark({
  product,
  size,
  className = "",
  testId,
  loading = "lazy",
}) {
  const mark = PRODUCTS[product];
  if (!mark) return null;

  const sizes = mark.officialLockup ? OFFICIAL_SHIELD_WORDMARK_SIZES : PRODUCT_WORDMARK_SIZES;
  const sizeClass = size ? sizes[size] || "" : "";

  return (
    <img
      src={mark.src}
      alt={mark.alt}
      width={mark.width}
      height={mark.height}
      loading={loading}
      decoding="async"
      draggable={false}
      className={`select-none object-contain ${sizeClass} ${className}`.trim().replace(/\s+/g, " ")}
      data-testid={testId || `product-wordmark-${product}`}
      data-wordmark-size={size || undefined}
    />
  );
}

export { PRODUCTS as PRODUCT_WORDMARKS };
